let cachedBasePath: string | null = null;

function withSlashes(path: string): string {
  if (!path || path === ".") return "/";
  const clean = path.startsWith("/") ? path : `/${path}`;
  return clean.endsWith("/") ? clean : `${clean}/`;
}

function detectBasePath(): string {
  const assetScript = Array.from(document.scripts)
    .map((script) => script.src)
    .find((src) => {
      try {
        return new URL(src, window.location.href).pathname.includes("/assets/");
      } catch {
        return false;
      }
    });

  if (assetScript) {
    const path = new URL(assetScript, window.location.href).pathname;
    return withSlashes(path.slice(0, path.indexOf("/assets/")));
  }

  const viteBase = import.meta.env.BASE_URL;
  if (viteBase && viteBase !== "./") {
    return withSlashes(viteBase);
  }

  const path = window.location.pathname;
  const dossierMatch = path.match(/^(.*)\/d\/[A-Za-z0-9_-]+\/?$/);
  if (dossierMatch) return withSlashes(dossierMatch[1]);
  if (path.endsWith("/index.html")) return withSlashes(path.slice(0, -"index.html".length));
  if (path.endsWith("/")) return withSlashes(path);
  return withSlashes(path.replace(/\/[^/]*$/, ""));
}

export function appBasePath(): string {
  cachedBasePath ??= detectBasePath();
  return cachedBasePath;
}

export function appPath(path = ""): string {
  const base = appBasePath();
  const clean = path.replace(/^\/+/, "");
  return `${base}${clean}`;
}

export function appUrl(path = ""): string {
  return new URL(appPath(path), window.location.origin).href;
}

export function apiPath(path = ""): string {
  return appPath(`api/${path.replace(/^\/+/, "")}`);
}

export function assetPath(path: string): string {
  if (/^(?:https?:|data:|blob:)/i.test(path)) return path;
  return appPath(path.replace(/^\/+/, ""));
}

export function stripAppBase(pathname: string): string {
  const base = appBasePath();
  if (base !== "/" && pathname.startsWith(base)) {
    return `/${pathname.slice(base.length)}`;
  }
  return pathname;
}
